import { useState } from 'react';

import {
  TagRead,
  useTagsListQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';
import { Tag } from 'src/common/tags/Tag/Tag';

interface TagFilterProps {
  selectedTags: TagRead[];
  onTagChange: (tags: TagRead[]) => void;
  dataTestId: string;
}

export function TagFilter({
  selectedTags,
  onTagChange,
  dataTestId,
}: TagFilterProps) {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const {
    data: tags,
    isLoading: tagsLoading,
    isFetching: tagsFetching,
  } = useTagsListQuery({
    search: debouncedSearchTerm,
  });

  return (
    <ItemSelector
      items={tags?.results || []}
      selectedItems={selectedTags}
      loading={tagsLoading}
      searching={tagsFetching}
      onSelectionChange={onTagChange}
      onSearchChange={setDebouncedSearchTerm}
      searchPlaceholder="Search tags"
      getItemLabel={(tag) => tag.tag_name}
      renderItem={(tag) => (
        <Tag label={tag.tag_name} color={tag.color_hex || '#DDD'} />
      )}
      dataTestId={dataTestId}
      noItemsText="No tags found."
    />
  );
}
